import { Alert, Box, Button, Checkbox, CircularProgress, FormControl, FormControlLabel, FormLabel, IconButton, InputAdornment, Link, Snackbar, TextField, Typography, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import logo_small from '../../assets/logo_small.png';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { AwsService } from '../../services/awsService';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { authenticate, dismissError } from '../../store/actions/authentication';

const HomeUnauthenticated: React.FC = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [login, setLogin] = useState("");
    const [password, setPassword] = useState("");
    const [keepLogged, setKeepLogged] = useState(false);
    const authenticating = useAppSelector(state => state.authentication.authenticating);
    const error = useAppSelector(state => state.authentication.authError);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => { event.preventDefault(); };
    const theme = useTheme();
    const [showError, setShowError] = useState(false);

    

    const authenticateUser = async () => {
        dispatch(authenticate({ username: login, password: password }));
    }
    const dismiss = () => {
        setShowError(false);
        setTimeout(() => {
            dispatch(dismissError());
        }, 3000);
    }
    const handleReturn = (e:React.KeyboardEvent<HTMLDivElement>) => {
        if(e.key === "Enter"){
            e.preventDefault();
            authenticateUser();
        }
    }

    useEffect(() => {
        const awsService = new AwsService();
        awsService.unauthenticate();
    }, []);
    useEffect(() => {
        setShowError(error !== undefined);
    },[error])
    return <Box display={"flex"} flexDirection={"column"} alignItems={"start"} justifyContent={"space-evenly"}>
        <img src={logo_small} aria-label={t('A11yMainLogoAlt')}/>
        <Box display={"flex"} flexDirection={"column"} gap={"16px"}>
            <Typography variant={'h1'} letterSpacing={"-0.08em"}>{t('LoginPageTitle')}</Typography>
            <Typography variant={'body1'} fontWeight={"600"}>{t('LoginPageSubTitle')}</Typography>
            <FormControl>
                <FormLabel>{t('LoginPageEmail')}</FormLabel>
                <TextField disabled={authenticating} placeholder={t('LoginPageEmail')} variant="outlined" hiddenLabel={true} value={login} onChange={(e) => setLogin(e.target.value)} onKeyDown={handleReturn} inputProps={{ "aria-label": t('LoginPageEmail')}} />
            </FormControl>
            <FormControl>
                <FormLabel>{t('LoginPagePassword')}</FormLabel>
                <TextField placeholder={t('LoginPagePassword')} variant="outlined" hiddenLabel={true} value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={handleReturn}
                    type={showPassword ? 'text' : 'password'}
                    disabled={authenticating}
                    InputProps={{
                        endAdornment:
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                    }}
                    inputProps={{ "aria-label": t('LoginPagePassword') }}/>
            </FormControl>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                <FormControl>
                    <FormControlLabel control={<Checkbox checked={keepLogged} onChange={(e, checked: boolean) => setKeepLogged(checked)} />} label={t('LoginPageRemember')} disabled={authenticating} />
                </FormControl>
                <Link href="#" fontWeight={"600"}>{t('LoginPageForgotPassword')}</Link>
            </Box>
            <Button variant='contained' onClick={authenticateUser} disabled={authenticating}>
                {t('LoginPageSignInButton')}
                {authenticating && (<CircularProgress
                    size={24}
                    sx={{
                        color: theme.palette.primary.dark,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                    }}
                />)}
            </Button>
        </Box>
        <Box display={"flex"} justifyContent={"center"} alignSelf={"center"}>
            <Typography variant={'body1'} fontWeight={"600"}>{t('LoginPageNoAccount')} <Link href="#">{t('LoginPageSignUp')}</Link></Typography>
        </Box>
        <Snackbar
            open={showError}
            onClose={dismiss}
            autoHideDuration={3000}
        >
            <Alert
                onClose={dismiss}
                severity="error"
                variant="filled"
                sx={{ width: '100%' }}
            >
                Unable to authenticate: {error}
            </Alert>
        </Snackbar>
    </Box>
}

export default HomeUnauthenticated;